import { createFileRoute } from "@tanstack/react-router";
import { AcceptInvitePage } from "@/features/settings/accept-invite-page";

// Outside the app frame: an invitee may be signed out, or signed in to another org.
export const Route = createFileRoute("/invite/$invitationId")({
  component: () => <AcceptInvitePage invitationId={Route.useParams().invitationId} />,
});
